import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { MenuTitleCategory } from "@/domain/main-header/entity/MenuTtitleCategory.interface";
import { MenuTitleSubCategory } from "@/domain/main-header/entity/MenuTitleSubCategory.interface";
import { MenuTitleCategoryDTO } from "@/domain/main-header/dto";
import { MenuTitle } from "@/domain/main-header/entity/MenuTitle.interface";

export class EventCategoriesConfigurationProvider {
    public static provideTo(events: Partial<MenuTitle>): Partial<MenuTitle> {
        const eventCategoriesData = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.EVENT_CATEGORIES) ?
            MainHeaderApplicationDataProvider.parseProvidedData<MenuTitleCategoryDTO[]>(ScriptSelector.EVENT_CATEGORIES)
            : null;

        if (!eventCategoriesData) {
            return events;
        }

        events.categories = this.normalizeEventCategoriesData(eventCategoriesData);

        return events
    }

    private static normalizeEventCategoriesData(data: MenuTitleCategoryDTO[]): MenuTitleCategory[] {
        return data.map((category: MenuTitleCategoryDTO) => {
            return {
                id: category.id ?? '',
                name: category.name ?? '',
                title: category.title ?? '',
                url: category.url ?? '',
                label: category.label ?? '',
                auth: category.auth ?? false,
                showChildren: category.showChildren ?? false,
                subCategories: this.normalizeSubCategoriesData(category.children),
            }
        });
    }

    private static normalizeSubCategoriesData(data: MenuTitleSubCategory[]): MenuTitleSubCategory[] {
        return data.map((subCategory: MenuTitleSubCategory) => {
            return {
                id: subCategory.id ?? '',
                name: subCategory.name ?? '',
                title: subCategory.title ?? '',
                url: subCategory.url ?? '',
            }
        });
    }
}